module.exports = __webpack_public_path__ + "static/media/save.68340fc4.svg";